import type { Registry as Services } from '@ember/service';
import { PRODUCT_NAMES } from 'frontend-utils/utils/constants/constant-values';
import { DRAWER_IDS } from 'lumen/utils/constants/general-constants';
import { SMART_INSIGHTS_TOUR_ID } from 'lumen/utils/constants/smart-insights';
import hasUnseenInsights from 'lumen/utils/smart-insights/has-unseen-insights';
import type { SmartInsightsButtonProps } from 'shared-react/lumen';

export interface SmartInsightsButtonController {
  drawer: Services['drawer'];
  intercom: Services['intercom'];
  smartInsights: Services['smart-insights'];
  toggleSmartInsightsDrawer: () => unknown;
  usageAnalytics: Services['usage-analytics'];
}

export default function createSmartInsightsButtonProps(
  controller: SmartInsightsButtonController,
): SmartInsightsButtonProps {
  const { drawer, intercom, smartInsights, usageAnalytics } = controller;

  return {
    hasUnseenInsights: hasUnseenInsights(
      smartInsights,
      drawer.isDrawerExpanded(DRAWER_IDS.SMART_INSIGHTS_DRAWER),
    ),
    onClick: (): void => {
      void controller.toggleSmartInsightsDrawer();

      if (drawer.isDrawerExpanded(DRAWER_IDS.SMART_INSIGHTS_DRAWER)) {
        intercom.startTour(SMART_INSIGHTS_TOUR_ID);

        usageAnalytics.track('Smart Insights Viewed', {
          eventTrigger: 'smart-insights-calendar',
          product: 'smart-insights',
        });

        usageAnalytics.initialiseSessionReplay({
          product: PRODUCT_NAMES.PRODUCT_SMART_INSIGHTS,
        });
      }

      if (smartInsights.hasInsights) {
        smartInsights.storeHasSeenDictInLocalStorage();
      }
    },
  };
}
